import { FaroCoreApiUtils } from "@stellar/core-api-client";

/**
 * Returns why a member cannot be given a SCENE seat, or undefined when they can be given one.
 *
 * Any member can hold a seat, including one that did not accept their workspace invite yet. Teams
 * are not users at all and can therefore never hold one.
 */
export function getSceneLicenseBlockReason(member) {
  if (FaroCoreApiUtils.Member.isTeam(member)) {
    return "Teams cannot hold a SCENE seat";
  }
  return undefined;
}